<script lang="ts">
	import cake from "../../../core/assets/icons/cake.svg?raw";
	import { customCakesEnquiryPathMap, customCakesPathMap } from "../../../core/schema/paths/customCakesPathMap";
	import { iceCreamAnchor } from "../../../core/schema/paths/homepagePathMap";
	import { weddingsCakeEnquiryPathMap, weddingsPathMap } from "../../../core/schema/paths/weddingsPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";
	import Link from "./Link.svelte";
	import iceCream from "../../../core/assets/icons/ice-cream.svg?raw";
	import Icon from "./Icon.svelte";

	export let hide = false;
	export let type: "wedding" | "customCakes" | "iceCream";

	const { TENANT_LOCALE } = getGlobalSettings();

	const urlSlugMap = {
		wedding: `/${weddingsPathMap[TENANT_LOCALE]}#${weddingsCakeEnquiryPathMap[TENANT_LOCALE]}`,
		customCakes: `/${customCakesPathMap[TENANT_LOCALE]}#${customCakesEnquiryPathMap[TENANT_LOCALE]}`,
		iceCream: `/#${iceCreamAnchor[TENANT_LOCALE]}`,
	};

	const textMap = {
		wedding: "Chci svatební dort od Sladké dílny",
		customCakes: "Chci dort na míru od Sladké dílny",
		iceCream: "Dnešní točená zmrzlina Čakovice a Petřiny",
	};

	const textButton = {
		wedding: "Poptat termín svatby",
		customCakes: "Poptat termín výroby",
		iceCream: "Chci si zajít na zmrzlinu",
	};

	const showButtonIcon = {
		wedding: true,
		customCakes: true,
		iceCream: false,
	};

	const urlSlug = urlSlugMap[type];
</script>

<div
	class="pointer-events-none fixed bottom-0 left-0 right-0 z-40 h-[7.25rem] transition-transform sm:h-[6.5rem]"
	class:translate-y-full={hide}
>
	<div class="h-[2.25rem] bg-panel-shadow"></div>
	<div
		class="pointer-events-auto flex h-[calc(100%-2.25rem)] flex-col items-center justify-center gap-1 border-t border-secondary-150 bg-white py-2 sm:flex-row sm:gap-12 lg:gap-16 xl:gap-20"
	>
		<div class="flex items-center">
			{#if type === "iceCream"}
				<Icon class="h-8 md:h-10" icon={iceCream} />
			{/if}
			<p class="text-xs font-medium text-black sm:text-base sm:font-semibold lg:text-md">{textMap[type]}</p>
		</div>
		<Link
			asButton
			type="submit"
			variant="primary"
			icon={showButtonIcon[type] ? cake : undefined}
			iconClass="h-4"
			href={urlSlug}
		>
			{textButton[type]}
		</Link>
	</div>
</div>
